import React, { useEffect, useState } from "react";
import { Dialog } from "usebeauty";
import ismobile from "is-mobile";

const DeviceCheck = ({ children }: { children: React.ReactElement }) => {
  const [isMobile, setIsMobile] = useState(true);
  const [isPortrait, setIsPortrait] = useState(true);

  const resizeHandler = () => {
    const isMobile = ismobile({ tablet: true });
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;

    setIsMobile(() => isMobile);
    setIsPortrait(() => isPortrait);
  };

  useEffect(() => {
    resizeHandler();
    window.addEventListener("resize", resizeHandler);
    return () => window.removeEventListener("resize", resizeHandler);
  }, []);

  return (
    <>
      {isMobile && isPortrait && children}
      <Dialog
        open={!isMobile || !isPortrait}
        content={() => {
          return (
            <Dialog.Base st={{ width: "360px", backgroundColor: "#f7f8fc" }}>
              <Dialog.Content>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "220px",
                    color: "#000038",
                    fontSize: "18px",
                    fontWeight: "500",
                  }}>
                  {!isMobile ? "모바일에서 접속해 주세요" : !isPortrait ? "세로로 이용해 주세요" : ""}
                </div>
              </Dialog.Content>
            </Dialog.Base>
          );
        }}></Dialog>
    </>
  );
};

export default DeviceCheck;
